import { ValidationOptions } from "../../interfaces";

export type ResetPasswordFormFieldName = "email" ;

export interface ResetPasswordFormDataType {
  email: string;
}

export interface ResetPasswordFields {
  id: string;
  type: string;
  label: string;
  placeholder: string;
  name: ResetPasswordFormFieldName;
  validation: ValidationOptions;
}

export const resetPasswordFields: Record<
ResetPasswordFormFieldName,
ResetPasswordFields
> = {
 email:{
    label: "Email",
    id: "email",
    type: "email",
    name: "email",
    placeholder: "Email",
    validation: {
      required: true,
      pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    },
  },
};

export const getEmailErrorMessages = ({
  email,
}: any): Record<string, string> => ({
  required: "The email address you entered is not registered. Please check and try again.",
  pattern: "The email address you entered is not registered. Please check and try again.",
  server: email?.message || "Server error",
});